export default "__VITE_ASSET__df125861__"